import axios from 'axios';
import {
  Loading,
  Message
} from 'element-ui'

function openLoading() {
  const loading = Loading.service({ // 声明一个loading对象
    lock: true, // 是否锁屏
    text: '正在加载...', // 加载动画的文字
    spinner: 'el-icon-loading', // 引入的loading图标
    background: 'rgba(0, 0, 0, 0.3)', // 背景颜色
    target: '.sub-main', // 需要遮罩的区域
    body: true,
    customClass: 'mask' // 遮罩层新增类名
  })
  return loading;
}

const succeedCode = 200

let baseURL = process.env.API;

if (process.env.NODE_ENV === 'development') {
  baseURL = 'http://172.24.17.213:8891/api/'  //华洋本地
} else {
  baseURL = "https://api.ccxanalytics.com/api/"  //生产
}

const $http = axios.create({
  baseURL,
})



export const get = (url, params) => {
  params = params || {};
  return new Promise((resolve, reject) => {
    $http.get(url, {
      params,
    }).then(res => {
      if (res.data.code === succeedCode) {
        resolve(res.data);
      } else {
        Message.error(res.data.message);
        reject('出错了')
      }
    }).catch(error => {
      Message.error('网络异常');
    })
  })
}

export const post = (url, params) => {
  params = params || {};
  return new Promise((resolve, reject) => {
    openLoading()
    $http.post(url, params).then(res => {
      if (res.data.code === succeedCode) {
        resolve(res.data);
      } else {
        Message.error(res.data.message);
        reject('出错了')
      }
      openLoading().close();
    }).catch(error => {
      Message.error('网络异常');
      openLoading().close();
    })
  })
}